import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { familyFeaturePreviewProduct } from 'reactApp/appHelpers/featuresHelpers/features/familyFunctions';
import { useFamilyShowPreviewHook } from 'reactApp/hooks/useFamilyShowHook';
import { openTariffBuy } from 'reactApp/modules/payment/payment.module';
import { productsController } from 'reactApp/modules/products/products.controller';
import opener from 'reactApp/utils/opener';
import { sendPaymentGa } from 'reactApp/utils/paymentGa';

const domain = process.env.NODE_ENV === 'development' ? 'mini-mail.ru' : 'mail.ru';
const calendarUrl = `https://calendar.${domain}`;

export const useFamilyCalendarClick = ({ paySource }: { paySource: string }) => {
    const dispatch = useDispatch();
    const showProductPay = useFamilyShowPreviewHook();

    return useCallback(async () => {
        if (showProductPay) {
            await productsController.loadProducts();
            dispatch(
                openTariffBuy({
                    productId: familyFeaturePreviewProduct,
                    paySource,
                    onSuccess: () => {
                        sendPaymentGa({ eventCategory: `family-tariff`, action: 'buy', source: familyFeaturePreviewProduct });
                    },
                })
            );
        } else {
            opener(calendarUrl);
        }
    }, [showProductPay]);
};
